const PrintableTableHeaderRow = (props) => {
  const { settings, title } = props;

  const topBorder = title ? "border-t-0" : "";
  const classStyleStart = ` border-zinc-300 border ${topBorder} px-2 h-full pb-2 pt-3 `;
  const classStyleMiddleEnd = ` border-zinc-300 border ${topBorder} border-l-0 px-2 h-full pb-2 pt-3 `;

  return (
    <thead>
      {title && (
        <tr className="row-start-start text-sm bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`border-zinc-300 border w-full  px-2 h-full pb-2 pt-3 `}
          >
            {title}
          </td>
        </tr>
      )}
      <tr className="row-start-start text-sm bg-zinc-100 font-semibold text-slate-800 ">
        {settings.map((setting, index) => {
          const randomKey = Math.random().toString(5).substring(2) + index;
          return (
            <td
              key={randomKey}
              className={`${
                index === 0 ? classStyleStart : classStyleMiddleEnd
              } ${setting.width} ${setting.layout}`}
            >
              {setting.label}
            </td>
          );
        })}
      </tr>
    </thead>
  );
};

export default PrintableTableHeaderRow;
